import React, { useContext, useEffect, useState } from 'react';
import { WithDataFetcher } from '../../Data/WithDataFetcher';
import { FormContext } from '../FormEngine';
import { getCancerCareFunds } from '../SpecialRules/CancerCareSpecialRules';
import SelectInput from './SelectInput';

//takes an onChange prop and calls it with (dataKey, newValue)
const CancerCareFundSelectInput = props => {
    // eslint-disable-next-line no-unused-vars
    const { def, data, dataKey, onChange } = props;
    const { getThenResolver } = props;
    const [funds, setFunds] = useState(null);

    const ctx = useContext(FormContext);

    useEffect(() => {
        async function loadFunds() {
            const funds = await getCancerCareFunds(getThenResolver, ctx.meta.assistanceProgramId);

            if (funds && funds.length > 0) {
                // find funds based on selected AssistanceService from application wizard
                // filter based on insurance selection
                var filteredFunds = funds
                    .find(f => f.assistanceServiceId === ctx.meta.assistanceServices[0].id).funds
                    .filter(f => {
                        const ins = ctx.formData['Insurance Patient Insurance Types CancerCare'];

                        return ins
                            ? f.insuranceClassName === ins
                            : true
                    })
                    .flatMap(f => f.funds);

                var fundOptions = [...new Set(filteredFunds)]
                    .sort((a, b) => a < b ? -1 : 1)
                    .map((fund, idx) => (
                        { key: `${fund}/${idx}`, value: fund, text: fund }
                    ));

                //fundOptions.unshift({ key: `empty${def.label}`, value: null, text: null});

                setFunds(fundOptions);
            }
        };

        loadFunds();
    
    }, []);

    if (!funds || funds.length === 0) { return null; }

    const checkValue = value => {
        if (funds) {
            let newValue = value;

            if (!funds.find(o => o.value === value)) {
                newValue = '';
            }

            if (newValue !== data) {
                ctx.specialRuleChangeData('CancerCare Medication Selection', '');
                onChange(dataKey, newValue);
            }
        }
    }

    const myProps = {
        ...props,
        def: {
            ...props.def,
            options: funds.map(f => f.text),
            values: funds.map(f => f.value)
        },
        onChange: (dataKey, value) => {
            checkValue(value);
            //ctx.specialRuleChangeData('CancerCare Medication Selection', '');
            //onChange(dataKey, value);
        },
        name: 'cancercarefundselectinput_de'
    }

    return <SelectInput {...myProps} />
}

export default WithDataFetcher(CancerCareFundSelectInput);
